// class declaration
export class MaterialListRequest {
    // variables
    public supplier_code;
    public company_code;
    public language;
    // editable variables
    public material_code;
}



// WEBPACK FOOTER //
// ./src/app/model/materials/material_list_request.model.ts